import { values, businessInfo } from "@/mocks/home";

export default function WhyUs() {
  return (
    <section id="nosotros" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-14 md:mb-20">
            <div className="order-2 lg:order-1">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold uppercase tracking-wider mb-5">
                <i className="ri-hand-heart-line"></i>
                Por qué elegirnos
              </span>
              <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight tracking-tight">
                Más que un laboratorio, un equipo que te cuida
              </h2>
              <p className="mt-5 text-base md:text-lg text-foreground-700 leading-relaxed">
                Sabemos que hacerse un estudio puede dar nervios. Por eso en ANEDAN tomamos el tiempo para
                explicarte cada paso con calma y profesionalismo. Aquí te recibimos con respeto, sin prisa y sin
                juicios: eres bienvenida y bienvenido tal como eres.
              </p>
              <p className="mt-4 text-base md:text-lg text-foreground-700 leading-relaxed">
                Combinamos tecnología confiable, instalaciones impecables y precios accesibles para que cuidar tu
                salud sea sencillo, cercano y humano.
              </p>

              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <a
                  href={businessInfo.phoneLink}
                  className="flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-fill"></i>
                  Llámanos: {businessInfo.phoneDisplay}
                </a>
                <a
                  href="#servicios"
                  className="flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-100 border border-background-300 text-foreground-900 text-sm font-semibold hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Ver servicios
                </a>
              </div>
            </div>

            <div className="order-1 lg:order-2 relative">
              <div className="w-full aspect-[4/5] md:aspect-[5/5] rounded-lg overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Friendly%20professional%20clinical%20laboratory%20team%20in%20clean%20white%20coats%20smiling%20warmly%20in%20a%20bright%20modern%20facility%2C%20soft%20natural%20light%2C%20teal%20turquoise%20and%20navy%20blue%20accents%2C%20welcoming%20inclusive%20atmosphere%2C%20editorial%20healthcare%20photography%2C%20caring%20and%20trustworthy%20mood&width=900&height=1000&seq=anedan-team-01&orientation=portrait&nocache=true"
                  alt="Equipo profesional del Laboratorio Clínico ANEDAN"
                  title="Atención profesional y humana en ANEDAN"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-5 left-4 md:left-auto md:-right-5 bg-background-50 rounded-lg border border-background-200 p-4 w-56 animate-float-soft">
                <div className="flex items-center gap-1 text-accent-500 mb-1">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-snug">
                  <strong className="text-foreground-950 font-semibold">{businessInfo.rating} estrellas</strong>{" "}
                  por nuestros pacientes en Google
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {values.map((value) => (
              <article
                key={value.title}
                className="group bg-background-100 border border-background-200/80 rounded-lg p-6 md:p-7 hover:border-primary-300 hover:bg-background-50 transition-colors duration-300"
              >
                <span className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                  <i className={`${value.icon} text-2xl`}></i>
                </span>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-2">
                  {value.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{value.description}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}